import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { Field, Formik, Form } from "formik";
import { useMutation, useQuery } from "react-query";
import Navbar from "../../Components/Navbar";
import axios from "axios";
import Config from "../../Config";
import {
  gDistrictsList,
  gRegionsList,
  gTypeOfRegistration,
  gTypeOfAssociations,
} from "../../Config";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  BoxSubTitle,
} from "../../Components/Styles/PageStyles";
import {
  SubmitBtn,
  PreviewBtn,
  OtherBtn,
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  CombineInputGroup,
} from "../../Components/Styles/InputStyles";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import moment from "moment";
import Select from "react-select";
import { HiUpload } from "react-icons/hi";
import { MdAdd, MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import { Update_User } from "../../Redux/actions";
import DropZone from "../../Components/Applications/Dropzone";
import { useTranslation } from "react-i18next";

const RegistrationForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openSenderIdModel, setOpenSenderIdModel] = useState(false);
  const [isSendLater, setIsSendLater] = useState(false);
  

  const [isSubmitable, setIsSubmitable] = useState(false);
                        

  const [uploadFile, setUploadFile] = useState("");
  const [rules, setRules] = useState("");
  const [memberNames, setMemberNames] = useState("");
  const [operatingDocs, setOperatingDocs] = useState("");
  const [financialDocs, setFinancialDocs] = useState("");
  const [mom, setMom] = useState("");
  const [coi, setcoi] = useState("");
  const [cor, setcor] = useState("");
  const [TIN, setTIN] = useState("");

  //console.log(allDistrictsList);

  const [districtsList, setDistricts] = useState([]);
  const [assocList, setAssociation] = useState([]);

  const { id } = useParams();

  const user = useSelector((state) => state?.UserReducer?.user);


  const [previewOpenModel, setPreviewOpenModel] = useState(false);
  
  const [isBasicFormOpen, setIsBasicFormOpen] = useState(true);
  const [isReportDetailsOpen, setIsReportDetailsOpen] = useState(true);

  // useEffect(() => {
  //   if (!previewOpenModel) setIsReportSent(false);
  // }, [previewOpenModel]);

  const toggleBasicFormOpen = () => setIsBasicFormOpen(!isBasicFormOpen);

  const toggleReportDetailsOpen = () =>
    setIsReportDetailsOpen(!isReportDetailsOpen);

  // -------------  Initial Data -------------
  // const fetchFunction = async () =>
  //   await axios.get(
  //     `${Config.nodeApiUrl}/getSenderIdContactGroups/sms`,
  //     Config.AxiosConfig
  //   );

  // const {
  //   data,
  //   error,
  //   isLoading: InitialLoading,
  // } = useQuery(`getSenderIdContactGroups`, fetchFunction);

  // -------------   Run Campaign  -------------
  const postFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/submitdocs`, values, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onSuccess = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      navigate("/my-applications");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoading, mutate: assocRegisterMutate } = useMutation(
    postFunction,
    {
      onSuccess: onSuccess,
      onError: onError,
    }
  );

  const InitialValue = {
    // assocName: "",
    // typeOfReg: "",
    // typeOfRegLabel: "",
    // typeOfAssoc: "",
    // typeOfAssocLabel: "",
    // region: "",
    // regionLabel: "",
    // district: "",
    // districtLabel: "",
    // officeAddr: "",
    // postalAddr: "",
    // objective: "",
    // affiliateInfo: "",
    // restrictionInfo: "",
    // noOfMembers: "",
    // formationDate: "",
    // name337: "",
    // number337: "",
    // purpose337: "",
    // landDetails: "",
    // officeBearTitle: "",
    // holderNames: "",
    // holdingTerms: "",
    // chairmanName: "",
    // chairmanSignature: "",
    // secretaryName: "",
    // secretarySignature: "",
    // annexADoc: "",
    // annexBDoc: "",
    rules: "",
    memberNames: "",
    operatingDocs: "",
    financialDocs: "",
    mom: "",
    TIN:"",
    cor:'',
    coi:'',
  };


  const SubmitHandler = (values) => {
    
      
      //  if (!values.rules) {
      //  return toast.error("Please select Chairman Signature");
      //  }
      //  else if (!values.memberNames) {
      //   return toast.error("Please select Chairman Signature");
      //  }
      //  else if (!values.operatingDocs) {
      //   return toast.error("Please select Chairman Signature");
      //  }
      //  else if (!values.financialDocs) {
      //   return toast.error("Please select Chairman Signature");
      //  }
      //  else if (!values.mom) {
      //   return toast.error("Please select Chairman Signature");
      //  }
       
      const body = new FormData();
      body.append("custId", user.id);
      body.append("appId", id);

      body.append("constitution", rules);
      body.append("members", memberNames);
      body.append("principals", operatingDocs);
      body.append("financials", financialDocs);
      body.append("mom", mom);
      body.append("coi", coi);
      body.append("cor", cor);
      body.append("TIN", TIN);


      assocRegisterMutate(body);
    
  };


  const RegistrationList = gTypeOfRegistration.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const AssociationList = assocList.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const RegionList = gRegionsList.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const SetDynamicDistricts = (value) => {
    //console.log(DistrictsList[value]);
    setDistricts(gDistrictsList[value]);
    //console.log(districtsList);
  };

  const SetDynamicAssociation = (value) => {
    //console.log(DistrictsList[value]);
    setAssociation(gTypeOfAssociations[value]);
    //console.log(districtsList);
  };

  const DistrictList = districtsList.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return (
    <>
      <Navbar />
      <Page>
        <BoxContainer>
          <BoxTitle onClick={() => navigate(-1)}>
            {/* <MdKeyboardArrowLeft className="text-gray-700 w-6 h-6" /> */}
            <p>{t("App_Registration")}</p>
          </BoxTitle>
          <Underline />
          <BoxSubTitle>{t("UploadDocument")}</BoxSubTitle>

          <Formik
            initialValues={InitialValue}
            onSubmit={SubmitHandler}
             // enableReinitialize={isInitialValueSaved}
          >
            {(formikProps) => (
              <>
                <Form>
                  <FormContainer className="md:mt-8">
                      <>

                        <InputGroup>
                          <Label htmlFor="rules">
                            {t("UploadConstitutionRules")}
                          </Label>
                          <DropZone setUploadFile={setRules} />
                        </InputGroup>


                        <InputGroup>
                          <Label htmlFor="mom">
                            {t("MomPdf")}
                          </Label>
                          <DropZone setUploadFile={setMom} />
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="financialDocs">
                            {t("UploadFinancialRegulation")}
                          </Label>
                          <DropZone setUploadFile={setFinancialDocs} />
                        </InputGroup>
                        
                        <InputGroup>
                          <Label htmlFor="operatingDocs">
                            {t("UploadOperatingPrinciples")}
                          </Label>
                          <DropZone setUploadFile={setOperatingDocs} />
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="memberNames">
                           {t("UploadMemberNames")}
                          </Label>
                          <DropZone setUploadFile={setMemberNames} />
                        </InputGroup>

                        <InputGroup>
                          <Label htmlFor="TIN">
                            {t("TIN_No_Certificate")}
                          </Label>
                          <DropZone setUploadFile={setTIN} />
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="cor">
                            {t("UploadRegistrationBrella")}
                          </Label>
                          <DropZone setUploadFile={setcor} />
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="coi">
                            {t("Upload_Incorporation")}
                          </Label>
                          <DropZone setUploadFile={setcoi} />
                        </InputGroup>

                      </>
                    
                  </FormContainer>

                  <div className="mt-14">
                  
                        <SubmitBtn type="submit" disabled={isLoading || !rules || !memberNames || !operatingDocs || !financialDocs || !mom} >
                          {isLoading && (
                            <Loading
                              color="white"
                              width={20}
                              height={20}
                              noPadding={true}
                            />
                          )}
                          {!isLoading && t('Submit')}
                        </SubmitBtn>
                   
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </BoxContainer>
      </Page>
    </>
  );
};

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-52 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const LabelCheckboxWrapper = tw.div``;
const CheckboxWrapper = tw.div`flex items-center space-x-5 mt-2.5`;

export default RegistrationForm;
